import type { ReactNode } from 'react';
import { Button, Flex, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import type { HotkeyActionId } from '@/shared/lib/hotkeys';
import { HotkeyTip } from './hotkey';

export interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  extra?: ReactNode;
  onBack?: boolean | (() => void);
  /** Действие каталога клавиш, которым страница уже обрабатывает «Назад» (например, `Esc`): его
   *  клавиша показывается в подсказке кнопки. */
  backHint?: HotkeyActionId;
}

/** antd v5 dropped `PageHeader` from core — this is the minimal replacement every page uses. */
export function PageHeader({ title, subtitle, extra, onBack, backHint }: PageHeaderProps) {
  const navigate = useNavigate();
  const handleBack = onBack === true ? () => navigate(-1) : onBack || undefined;

  return (
    <Flex
      align="flex-start"
      justify="space-between"
      gap={12}
      wrap="wrap"
      style={{ marginBottom: 16 }}
    >
      <Flex align="center" gap={8}>
        {handleBack ? (
          <HotkeyTip catalogId={backHint} label={backHint ? undefined : 'Назад'} display="inline-flex">
            <Button type="text" aria-label="back" icon={<ArrowLeftOutlined />} onClick={handleBack} />
          </HotkeyTip>
        ) : null}
        <div>
          <Typography.Title level={4} style={{ margin: 0 }}>
            {title}
          </Typography.Title>
          {subtitle ? <Typography.Text type="secondary">{subtitle}</Typography.Text> : null}
        </div>
      </Flex>
      {extra ? <Flex gap={8}>{extra}</Flex> : null}
    </Flex>
  );
}
